import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';

import * as components from './';

class SessionRoutes extends Component {
  render() {
    return (
      <Switch>
        <Route
          exact
          path="/sessions"
          component={components.ScheduleContainer}
        />
        <Route
          exact
          path="/sessions/new"
          component={components.SessionEditContainer}
        />
        <Route
          exact
          path="/sessions/new/:clientId"
          component={components.SessionEditContainer}
        />
        <Route
          exact
          path="/sessions/edit/:id"
          component={components.SessionEditContainer}
        />
        <Route
          exact
          path="/sessions/:id"
          component={components.SessionDetailContainer}
        />
      </Switch>
    );
  }
}

export default SessionRoutes;



// WEBPACK FOOTER //
// ./src/modules/sessions/components/SessionRoutes.js